var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    { ref: "tokenContainer", staticClass: "rtb-popover-container" },
    [
      _c("SearchableDropdown", {
        staticClass: "filter-comparison-type bulk-modifier-dropdown",
        attrs: {
          rules: "required",
          config: _vm.bulkTagOptions,
          placeholder: _vm.$t("SELECT_BULK_MODIFIER_PH"),
          searchable: true,
          clearable: false
        },
        on: { change: _vm.onSelectedBulkModifier },
        model: {
          value: _vm.selectedTag,
          callback: function($$v) {
            _vm.selectedTag = $$v
          },
          expression: "selectedTag"
        }
      }),
      _vm._v(" "),
      _c("InputFile", {
        directives: [
          {
            name: "tooltip",
            rawName: "v-tooltip",
            value: _vm.$t("SELECT_BULK_MODIFIER_BUTTON_TT"),
            expression: "$t('SELECT_BULK_MODIFIER_BUTTON_TT')"
          }
        ],
        attrs: { accept: ".csv,.txt", "show-file-name": false },
        on: { change: _vm.onFileUpload }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }